import { useState } from "react";
import { BASE_API_PATHS } from "../../constants/apis.constants";
import { postData, postJsonData } from "../../Utils/commonApi";
import useBaseActions from "./base.actions";
import { CallToast } from "../../Components/PriceCalculator/modals/CustomToast";

const useAIActions = () => {
  const { authTokens } = useBaseActions();
  const [isAssistantLoading, setIsAssistantLoading] = useState(false);

  const aiAssistant = ({ prompt }) => {
    if (!prompt) {
      throw new Error('Prompt is required');
    }
    setIsAssistantLoading(true);
    return postData(authTokens, BASE_API_PATHS.aiAssistant, {
      ChatOrMap: 0,
      queryOrTeach: 0,
      Prompt: prompt
    })
      .then((response) => {
        if (typeof response === 'string' && response.includes('{')) {
          const data = JSON.parse(response);
          const message = data?.choices?.[0]?.message?.content;
          if (!message) {
            CallToast("Something went wrong", false, false, "v2style")
            throw new Error('No message found');
          }
          return {
            message
          }
        } else {
          throw new Error('No message found');
        }
      })
      .finally(() => {
        setIsAssistantLoading(false);
      });
  }

  const generateImageWithDallE = ({ prompt, size = "1024x1024", style = "natural" }) => {
    if (!prompt) {
      throw new Error('Prompt is required');
    }
    setIsAssistantLoading(true);
    return postJsonData(authTokens, BASE_API_PATHS.generateImageWithDallE, {
      "prompt": prompt,
      "numberOfImages": 1,
      "size": size,
      "quality": "standard",
      "style": style,
      "responseFormat": "url",
      "saveImages": false
    })
      .then((response) => {
        if (typeof response === 'object' && response?.data[0]) {
          const url = response?.data?.[0]?.url;
          if (!url) {
            CallToast("Something went wrong", false, false, "v2style")
            throw new Error('No url found');
          }
          return {
            message: url
          }
        } else {
          CallToast("Something went wrong", false, false, "v2style")
          throw new Error('No url found');
        }
      })
      .finally(() => {
        setIsAssistantLoading(false);
      });
  }

  return {
    aiAssistant,
    isAssistantLoading,
    generateImageWithDallE
  }
}

export default useAIActions;
